import { yupResolver } from '@hookform/resolvers/yup';
import { useState } from 'react';
import { ISolicitationViewModel, ISpecialtyViewModel } from 'viewModels';
import Tooltip from '@mui/material/Tooltip';
import { Button as ButtonMUI, Grid, Typography } from '@mui/material';
import * as yup from 'yup';
import { IAddSpecialtiesInputModel, IDeleteSpecialtiesInputModel } from 'inputModels';
import { useForm } from 'react-hook-form';
import { useTheme } from 'styled-components';
import { NavHeader } from '../../components/NavHeader';
import { useApp, useAuth } from '../../context';
import { ReactComponent as DeleteIcon } from '../../assets/icons/IconTrashCan.svg';
import { MenuOptionLeftCompany } from '../../components/MenuOptionLeft/Company';
import SpecialtyController from '../../controller/SpecialtyController';
import { Button, Input } from '../../components';
import { Body, Container, Content } from './styles';
import { useSpecialties } from '../../context/specialties';
import { ModalDeleteSpecialties } from '../../components/Modals/ModalDeleteSpecialties';
import { useAlert } from '../../hooks/useAlert';

export function Specialties() {
  const app = useApp();
  const alert = useAlert();
  const { user } = useAuth();
  const { setSpecialtiesSelectedByUser } = useSpecialties();
  const correspondenceSchema: yup.SchemaOf<IAddSpecialtiesInputModel> = yup.object().shape({
    name: yup.string().required('O campo nome é obrigatório'),
  });
  const { colors } = useTheme();
  const [defaultValue] = useState({
    name: '',
  });
  const [specialtyByCorrespondence, setSpecialtyByCorrespondence] = useState<
    ISolicitationViewModel[]
  >([]);
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
  const [specialtySelected, setSpecialtySelected] = useState<ISpecialtyViewModel>({
    id: '',
    name: '',
  });
  const { specialties, setSpecialties } = useSpecialties();
  const {
    handleSubmit,
    reset,
    formState: { errors },
    control,
  } = useForm({
    defaultValues: defaultValue,
    reValidateMode: 'onChange',
    resolver: yupResolver(correspondenceSchema),
  });
  const addSpecialties = async (data: IAddSpecialtiesInputModel) => {
    app.setLoading(true);
    SpecialtyController.AddSpecialties(data)
      .then((response) => {
        const newSpecialty: ISpecialtyViewModel = {
          id: response,
          name: data.name,
          createdById: user.id,
          disabled: false,
        };
        setSpecialties((prev) =>
          [...prev, newSpecialty].sort((a, b) => a.name.localeCompare(b.name)),
        );
        alert.show({ message: 'Especialidade adicionada com sucesso!', type: 'success' });
      })
      .catch(() => {
        alert.show({ message: 'Erro ao adicionar especialidade!', type: 'error' });
      })
      .finally(() => app.setLoading(false));
    reset();
  };
  const deleteSpecialties = async (data: IDeleteSpecialtiesInputModel) => {
    app.setLoading(true);
    SpecialtyController.DeleteSpecialty(data)
      .then(() => {
        setSpecialtiesSelectedByUser((prev) => prev.filter((el) => el.id !== data.id));
        setSpecialties(specialties.filter((el) => el.id !== data.id));
        alert.show({ message: 'Especialidade removida com sucesso!', type: 'success' });
      })
      .catch(() => {
        alert.show({ message: 'Erro ao remover especialidade!', type: 'error' });
      })
      .finally(() => app.setLoading(false));
  };
  const handleVerifyHasSolicitation = async (specialty: ISpecialtyViewModel) => {
    app.setLoading(true);
    setSpecialtySelected(specialty);
    SpecialtyController.SpecialtyHasSolicitation(specialty.id)
      .then((response) => {
        setSpecialtyByCorrespondence(response);
        setIsOpenDeleteModal(true);
      })
      .catch(() => {
        setSpecialtyByCorrespondence([]);
        setIsOpenDeleteModal(true);
        alert.show({ message: 'Erro ao verificar solicitações!', type: 'error' });
      })
      .finally(() => app.setLoading(false));
  };

  return (
    <>
      <NavHeader typeHeader="company" />
      <Body>
        <MenuOptionLeftCompany />
        <Container>
          <div className="header">
            <h1>Adicionar Especialidade</h1>
          </div>
          <Content>
            <Input
              name="name"
              placeholder="Nome"
              control={control}
              variant="standard"
              errorText={errors.name?.message}
              lengthInput={100}
            />
            <div className="add">
              <Button
                text="Adicionar"
                dimensions={{ width: '13rem', height: '2.25rem' }}
                onClick={handleSubmit(addSpecialties)}
              />
            </div>
          </Content>
          <h2>Cadastrados</h2>
          <div className="branchesList">
            {specialties?.length ? (
              specialties
                .filter((s) => s.createdById)
                .map((s) => (
                  <Tooltip disableInteractive key={s.id} title={s.name} placement="top-start" arrow>
                    <div className="branch" key={s.id}>
                      <div className="headerBranch">
                        <h1>{s.name}</h1>
                        {s.createdById && (
                          <div>
                            <ButtonMUI
                              type="button"
                              onClick={() => handleVerifyHasSolicitation(s)}
                              className="delete">
                              <DeleteIcon />
                            </ButtonMUI>
                          </div>
                        )}
                      </div>
                    </div>
                  </Tooltip>
                ))
            ) : (
              <Grid container padding="2rem" justifyContent="center">
                <Typography justifyContent="center" align="center" color={colors.primary}>
                  Nenhuma Especialidade encontrada...
                </Typography>
              </Grid>
            )}
          </div>
        </Container>
        <ModalDeleteSpecialties
          isOpen={isOpenDeleteModal}
          currentSpecialtySelected={specialtySelected}
          onRequestClose={() => setIsOpenDeleteModal(false)}
          onRequestRemoveSpecialty={deleteSpecialties}
          solicitationBySpecialty={specialtyByCorrespondence}
        />
      </Body>
    </>
  );
}
